import i18next from 'i18next'

export const sortObjectsByLabel = (e1: { label: string }, e2: { label: string }) => {
  return e1.label.localeCompare(e2.label, i18next.language)
}

export const compareObjectsByName = (e1: { name: string }, e2: { name: string }) => {
  return e1.name.localeCompare(e2.name, i18next.language, { sensitivity: 'base', numeric: true })
}

export const formatNumber = (value?: number, locale?: string): string | undefined => {
  if (value === undefined) {
    return undefined
  }

  const localeToUse = locale || i18next.language
  let numericFormatter = new Intl.NumberFormat(localeToUse)

  if (Math.abs(value) >= 10e5) {
    numericFormatter = new Intl.NumberFormat(localeToUse, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore : TypeScript still "thinks" that notation is experimental, but it is not the case anymore :
      // ==> https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
      notation: 'compact',
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore : TypeScript still "thinks" that notation is experimental, but it is not the case anymore :
      // ==> https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
      compactDisplay: 'short',
    })
  }

  return numericFormatter.format(value)
}

export const insert = (list: any[], element: any, index: number) => list.splice(index, 0, element)

function lexicographicCompare(labelA: string, labelB: string): number {
  const matchA = labelA.match(/\d+/)
  const matchB = labelB.match(/\d+/)
  if (matchA && matchA.index === 0 && matchB && matchB.index === 0) {
    // Both labels starts with digits
    return parseInt(matchA[0], 10) - parseInt(matchB[0], 10)
  }

  if (
    matchA &&
    matchB &&
    matchA.index === matchB.index &&
    labelA.slice(0, matchA.index) === labelB.slice(0, matchB.index)
  ) {
    // Both labels starts with same string and have a number => we can sort using this number
    return parseInt(matchA[0], 10) - parseInt(matchB[0], 10)
  }

  return labelA.toLowerCase() > labelB.toLowerCase() ? 1 : -1
}

export function lexicographicSort(collections: any[], key = 'label') {
  return collections.sort((a, b) => lexicographicCompare(a[key] || '', b[key] || ''))
}

/**
 * Restrict value between min max
 *
 * It differs from lodash clamp by allowing to receive undefined min and max allowing for easier usage
 */
export const clamp = function (value: number, min: number | undefined, max: number | undefined) {
  if (min != undefined && value < min) {
    value = min
  }

  if (max != undefined && value > max) {
    value = max
  }

  return value
}
